// extracted by mini-css-extract-plugin
export default {"iframe":"Ipsndk","placeholder":"HR7owy","displayNone":"fHaYoE"};